import React from 'react';
import { MiniCartCheckoutButton } from './CheckoutButton';
import { MiniCartAddNote } from './AddNote';
import { MiniCartAddGiftWrap } from './AddGiftWrap';

type MiniCartFooterProps = {
  addNoteText: string;
  editNoteText: string;
  proceedCta: string;
  addGiftWrapText: string;
  excludedSkus: string;
  giftWrapProduct: {
    id: number;
    price: number;
  };
  saveNoteText: string;
  addNotePlaceholderText: string;
};

export function MiniCartFooter({
  addNoteText,
  editNoteText,
  addGiftWrapText,
  giftWrapProduct,
  excludedSkus,
  proceedCta,
  saveNoteText,
  addNotePlaceholderText,
}: MiniCartFooterProps): JSX.Element {
  return (
    <footer className="minicart-footer">
      <div className="minicart-footer-note-and-gift-wrap">
        <MiniCartAddNote
          addNoteText={addNoteText}
          editNoteText={editNoteText}
          saveNoteText={saveNoteText}
          addNotePlaceholderText={addNotePlaceholderText}
        />
        {giftWrapProduct ? (
          <MiniCartAddGiftWrap
            giftWrapProduct={giftWrapProduct}
            excludedSkus={excludedSkus}
          >
            {addGiftWrapText}
          </MiniCartAddGiftWrap>
        ) : null}
      </div>
      <MiniCartCheckoutButton>{proceedCta}</MiniCartCheckoutButton>
    </footer>
  );
}
